import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import Modal from "modal-react-native-web";
import { Feather } from "@expo/vector-icons";
import { pickImage } from "../../action/authImage";
import { apiservice } from "../../service/service";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import moment from "moment";
const { width, height } = Dimensions.get("window");
export default function adddaily({ navigation, route }) {
  const [token, setToken] = useRecoilState(tokenState);
  const [state1, setstate1] = useState({
    img: [],
  });
  const [modalresult, setModalresult] = useState(false);
  const placeholder = {
    label: "",
    value: null,
    color: "#777777",
  };
  const [items, setItems] = useState([
    { label: "โกลด์", value: "โกลด์" },
    { label: "ไดมอนด์", value: "ไดมอนด์" },
  ]);
  const [body, setbody] = useState({
    reward: [
      { coin: "", iamge: "" },
      { coin: "", iamge: "" },
      { coin: "", iamge: "" },
      { coin: "", iamge: "" },
      { coin: "", iamge: "" },
      { coin: "", iamge: "" },
      { coin: "", iamge: "" },
    ],
    number_weekend: route?.params?.week,
    month: moment(route?.params?.body).format("M"),
    year: moment(route?.params?.body).format("YYYY"),
    status: true,
  });

  console.log(route?.params?.body);
  console.log(new Date(route?.params?.body));

  console.log(moment().format("M"));
  console.log(moment().format("YYYY"));

  useEffect(() => {
    if (route?.params?.weekdata) {
      setbody(route?.params?.weekdata);
    }
  }, []);

  return (
    <View style={styles.container}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modalresult}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalresult(!modalresult);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.34,
              alignSelf: "center",
              justifyContent: "center",
            }}
          >
            <FlatList
              // data={data}
              numColumns={3}
              renderItem={({ item }) => {
                return (
                  <TouchableOpacity
                    onPress={() => setModalresult(!modalresult)}
                    style={styles.touchflat}
                  >
                    <Text style={styles.textday}>{item.date}</Text>
                    <Image source={item.img} style={styles.img1} />
                    <Text style={styles.textprice}>{item.price}</Text>
                  </TouchableOpacity>
                );
              }}
            />
            <TouchableOpacity style={styles.touchday}>
              <Text style={styles.textday}>7 day</Text>
              <Image
                source={require("../../image/coin.png")}
                style={styles.img1}
              />
              <Text style={styles.textprice}>150</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              DAILY BONUS{" "}
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>ADD</Text>
              </Text>
            </Text>
            <View
              style={{
                flexDirection: "row",
                width: width * 0.22,
                justifyContent: "space-between",
              }}
            >
              <TouchableOpacity
                onPress={async () => {
                  delete body.id;
                  const response = await apiservice({
                    path: "/freepoint/postdairybonus",
                    method: "post",
                    body: body,
                    token: token?.accessToken,
                  });

                  if (response.status == 200) {
                    navigation.navigate("AddBonus");
                  }
                }}
                style={styles.touchadd}
              >
                <Text style={styles.textadd}>SAVE</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  navigation.goBack();
                }}
                style={styles.touchadd}
              >
                <Text style={styles.textadd}>CANCEL</Text>
              </TouchableOpacity>
            </View>
          </View>

          <FlatList
            data={body.reward}
            extraData={state1.img}
            renderItem={({ item, index }) => {
              return (
                <View style={styles.view}>
                  <View style={styles.viewcoin}>
                    <Text style={styles.textday}>วันที่ {index + 1}</Text>
                    {item.iamge == "" ? (
                      <View style={styles.viewimg} />
                    ) : (
                      <Image
                        style={{ width: 90, height: 90, alignSelf: "center" }}
                        source={{
                          uri:

                            item.iamge,
                        }}
                      />
                    )}
                    <View>
                      <View style={{ flexDirection: "row", marginLeft: 20 }}>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await pickImage();
                            setbody((val) => ({
                              ...val,
                              reward: val.reward.map((items, indexs) => {
                                if (index == indexs) {
                                  return {
                                    ...items,
                                    iamge: response,
                                  };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={[
                            styles.bottomre,
                            { backgroundColor: "#FCC81D" },
                          ]}
                        >
                          <Text style={styles.textre}>Upload</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await apiservice({
                              path: "/image/delete/" + state1.img,
                              method: "delete",
                            });
                            setbody((val) => ({
                              ...val,
                              reward: val.reward.map((items, indexs) => {
                                if (index == indexs) {
                                  return {
                                    ...items,
                                    iamge: null,
                                  };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={styles.bottomre}
                        >
                          <Text style={styles.textre}>Reset</Text>
                        </TouchableOpacity>
                      </View>
                      <Text style={styles.textcoon}>
                        Allowed JPG, GIF or PNG. Max size of 800kB
                      </Text>
                    </View>
                  </View>
                  <View style={[styles.viewcoin, { borderRightColor: "#fff" }]}>
                    <View
                      style={{
                        width: width * 0.35,
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text style={[styles.textcoon, { alignSelf: "center" }]}>
                        ระบุจำนวนที่จะได้
                      </Text>
                      <TextInput
                        placeholder=""
                        style={styles.input}
                        value={item.coin}
                        onChangeText={(text) => {
                          setbody((val) => ({
                            ...val,
                            reward: val.reward.map((items, indexs) => {
                              if (index == indexs) {
                                return { ...items, coin: text };
                              } else {
                                return items;
                              }
                            }),
                          }));
                        }}
                      />
                      <Text style={[styles.textcoon, { alignSelf: "center" }]}>
                        หน่วย
                      </Text>
                      <View>
                        <RNPickerSelect
                          placeholder={placeholder}
                          onValueChange={(text) =>
                            setstate1({ ...state1, value: text })
                          }
                          style={{
                            inputWeb: {
                              width: 70,
                              height: 30,
                              borderWidth: 1,
                              borderColor: "#ccc",
                              paddingLeft: 10,
                              borderRadius: 5,
                              color: "#777777",
                              fontFamily: "Prompt-Regular",
                              alignSelf: "center",
                              alignItems: "center",
                              marginTop: 28,
                            },
                          }}
                          items={items}
                        />
                      </View>
                    </View>
                  </View>
                </View>
              );
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.83,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#FCC81D",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  view: {
    justifyContent: "space-between",
    width: width * 0.83,
    flexDirection: "row",
    backgroundColor: "#FFF",
    height: 105,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 10,
    marginTop: 10,
    padding: 5,
  },
  viewcoin: {
    width: width * 0.4,
    height: 95,
    flexDirection: "row",
    borderRightWidth: 0.5,
    borderColor: "#444",
    padding: 5,
    justifyContent: "space-between",
  },
  textday: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    marginRight: 10,
  },
  viewimg: {
    width: 90,
    height: 90,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
  },
  img: {
    width: 90,
    height: 90,
  },
  bottomre: {
    width: 120,
    height: 35,
    borderWidth: 0.1,
    borderColor: "#DBDBDB",
    justifyContent: "center",
    marginRight: 20,
  },
  textre: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
    alignSelf: "center",
  },
  textcoon: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#000",
    marginLeft: 20,
    marginTop: 10,
  },
  input: {
    width: 50,
    height: 30,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    paddingLeft: 5,
    alignSelf: "center",
  },
  touchsave: {
    width: 120,
    height: 40,
    borderRadius: 5,
    backgroundColor: "#FCC81D",
    justifyContent: "center",
    alignSelf: "center",
  },
  touchflat: {
    width: 100,
    height: 100,
    borderRadius: 20,
    backgroundColor: "#FCC81D",
    justifyContent: "center",
    marginHorizontal: 17,
    marginTop: 17,
    alignSelf: "center",
  },
  textday: {
    fontFamily: "Prompt-Regular",
    fontSize: 13,
    color: "#000",
    marginLeft: 5,
  },
  img1: {
    width: 37,
    height: 37,
    alignSelf: "center",
  },
  textprice: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#000",
    alignSelf: "center",
  },
  touchday: {
    width: 370,
    height: 100,
    borderRadius: 20,
    backgroundColor: "#FCC81D",
    justifyContent: "center",
    alignSelf: "center",
    marginVertical: 17,
    marginLeft: -60,
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
});
